<!-- <app-thing-banner [items]="[['Bedienung über Kacheln','#OperIcons'], ['Bedienung über Dropdownlisten','#OperDropDown']]"></app-thing-banner> -->
<app-help-page-banner [items]="[['Bedienung über Kacheln', 'Operation via icons', 'OperIcons']]" [returnAddress]="'/HelpPage'">
</app-help-page-banner>
<div class="container">
    <!-- StartPage -->
    <h2>{{'Menüführung' | translate}}</h2>
    <h3 class="subheading" id="OperIcons">{{'Bedienung über Kacheln' | translate}}</h3>
    <img id="imageOperIcons"
         src="{{environment.storageUrl}}/models3d/general\helpPage\introduction\MenuNavigation/Operation ViaIcons_{{urlLanguage}}.png"
         class="embed-responsive mx-auto d-block" style="width: 45%;">
</div>
